import React, { useEffect, useRef } from 'react';

import type { Antibot } from '../antibot.js';

/**
 * Recipiente do desafio antibot — mesmo padrão do componente hoje definido em
 * `App.tsx` para a tela OTP. A montagem acontece num efeito porque envolve
 * carregar um script externo; sem chave configurada, o recipiente fica vazio e
 * a tela só descobre isso quando alguém tenta enviar.
 */
export const DesafioAntibot: React.FC<{ readonly antibot: Antibot }> = ({ antibot }) => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const alvo = container.current;
    if (alvo === null) {
      return;
    }
    void antibot.montar(alvo);
    return () => {
      antibot.desmontar();
    };
  }, [antibot]);

  return <div ref={container} data-testid="desafio-antibot" />;
};
